/* baseReducer */
export const FETCH_BASE_START = 'FETCH_BASE_START';
export const FETCH_BASE_DONE = 'FETCH_BASE_DONE';
export const RECEIVE_BASE = 'RECEIVE_BASE';

/* filmsReducer */
export const FETCH_FILMS_START = 'FETCH_FILMS_START';
export const FETCH_FILMS_DONE = 'FETCH_FILMS_DONE';
export const RECEIVE_FILMS = 'RECEIVE_FILMS';
export const FETCH_FILM_START = 'FETCH_FILM_START';
export const FETCH_FILM_DONE = 'FETCH_FILM_DONE';
export const RECEIVE_FILM = 'RECEIVE_FILM';
export const FETCH_MORE_FILMS_START = 'FETCH_MORE_FILMS_START';
export const FETCH_MORE_FILMS_DONE = 'FETCH_MORE_FILMS_DONE';

/* peopleReducer */
export const FETCH_PEOPLE_START = 'FETCH_PEOPLE_START';
export const FETCH_PEOPLE_DONE = 'FETCH_PEOPLE_DONE';
export const RECEIVE_PEOPLE = 'RECEIVE_PEOPLE';
export const FETCH_PERSON_START = 'FETCH_PERSON_START';
export const FETCH_PERSON_DONE = 'FETCH_PERSON_DONE';
export const RECEIVE_PERSON = 'RECEIVE_PERSON';
export const FETCH_MORE_PEOPLE_START = 'FETCH_MORE_PEOPLE_START';
export const FETCH_MORE_PEOPLE_DONE = 'FETCH_MORE_PEOPLE_DONE';
export const RECEIVE_MORE_PEOPLE = 'RECEIVE_MORE_PEOPLE';

/* planetsReducer */
export const FETCH_PLANETS_START = 'FETCH_PLANETS_START';
export const FETCH_PLANETS_DONE = 'FETCH_PLANETS_DONE';
export const RECEIVE_PLANETS = 'RECEIVE_PLANETS';
export const FETCH_PLANET_START = 'FETCH_PLANET_START';
export const FETCH_PLANET_DONE = 'FETCH_PLANET_DONE';
export const RECEIVE_PLANET = 'RECEIVE_PLANET';

/* speciesReducer */
export const FETCH_SPECIESES_START = 'FETCH_SPECIESES_START';
export const FETCH_SPECIESES_DONE = 'FETCH_SPECIESES_DONE';
export const RECEIVE_SPECIESES = 'RECEIVE_SPECIESES';
export const FETCH_SPECIES_START = 'FETCH_SPECIES_START';
export const FETCH_SPECIES_DONE = 'FETCH_SPECIES_DONE';
export const RECEIVE_SPECIES = 'RECEIVE_SPECIES';

/* starshipsReducer */
export const FETCH_STARSHIPS_START = 'FETCH_STARSHIPS_START';
export const FETCH_STARSHIPS_DONE = 'FETCH_STARSHIPS_DONE';
export const RECEIVE_STARSHIPS = 'RECEIVE_STARSHIPS';
export const FETCH_STARSHIP_START = 'FETCH_STARSHIP_START';
export const FETCH_STARSHIP_DONE = 'FETCH_STARSHIP_DONE';
export const RECEIVE_STARSHIP = 'RECEIVE_STARSHIP';

/* vehiclesReducer */
export const FETCH_VEHICLES_START = 'FETCH_VEHICLES_START';
export const FETCH_VEHICLES_DONE = 'FETCH_VEHICLES_DONE';
export const RECEIVE_VEHICLES = 'RECEIVE_VEHICLES';
export const FETCH_VEHICLE_START = 'FETCH_VEHICLE_START';
export const FETCH_VEHICLE_DONE = 'FETCH_VEHICLE_DONE';
export const RECEIVE_VEHICLE = 'RECEIVE_VEHICLE';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/